export const settingsKeys = {
  all: ['user-settings'] as const,

  transactions: () => [...settingsKeys.all, 'transactions'] as const,

  notificationRules: () => [...settingsKeys.all, 'rules'] as const,
};
